import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Common_Vendor_Card from "../../../common_components/common-vendor-card/Common_Vendor_Card";
import Common_Headings from "../../../common_components/common_heading/Common_Headings";
import { getVendorExpert } from "../../../../features/admin/vendor_expert/Slice";

function Popular_Vendors({
  selectedMaterialIds,
  categories,
  activeTab,
  searchName,
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const plans =
    useSelector((state) => state?.vendor_expert?.vendorexperts?.vendorPlans) ||
    [];

  useEffect(() => {
    if (selectedMaterialIds.length) {
      dispatch(
        getVendorExpert({
          type: "vendor",
          material_id: selectedMaterialIds,
          search_name: searchName,
        }),
      );
    }
  }, [selectedMaterialIds, activeTab, searchName, dispatch]);

  if (!selectedMaterialIds.length) return null;

  return (
    <>
      {plans.length ? (
        plans.map((plan) => (
          <div className="mt-4 vendor-section">
            <Common_Headings
              title={plan?.name}
              onSeeAll={() =>
                navigate(
                  `/vendors?type=vendor&material_id[0]=${plan.id}&see_all_status=1`,
                )
              }
            />

            <div className="row">
              {plan?.vendors?.length ? (
                plan?.vendors?.map((vendor) => (
                  <div key={vendor.id} className="col-xl-4 col-sm-6 mb-4">
                    <Common_Vendor_Card vendor={vendor} />
                  </div>
                ))
              ) : (
                <p className="text-muted">No vendors found</p>
              )}
            </div>
          </div>
        ))
      ) : (
        <p className="text-muted">No vendors found</p>
      )}
    </>
  );
}

export default Popular_Vendors;
